/* PFUI&DEIFEL - minimale Bewegung, kein Framework.
   Scroll-Reveal per IntersectionObserver + weicher Anker-Scroll. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var items = document.querySelectorAll('.pd-reveal:not(.is-in)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.transitionDelay = (e.target.dataset.pdDelay || 0) + 'ms';
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  }

  function anchors() {
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest ? ev.target.closest('a[data-pd-scroll], header-drawer a[href*="#"]') : null;
      if (!a) return;

      var href = a.getAttribute('href') || '';
      var url;
      try { url = new URL(href, window.location.href); } catch (err) { return; }
      if (
        url.origin !== window.location.origin ||
        url.pathname !== window.location.pathname ||
        url.search !== window.location.search ||
        !url.hash ||
        url.hash === '#'
      ) return;

      var target;
      try { target = document.querySelector(url.hash); } catch (err) { return; }
      if (!target) return;

      ev.preventDefault();

      var drawer = a.closest ? a.closest('header-drawer') : null;
      if (drawer && typeof drawer.close === 'function') drawer.close();

      if (window.location.hash !== url.hash) {
        window.history.pushState(null, '', url.hash);
      }

      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function init() { reveal(); anchors(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', reveal);
})();
